// NotFoundPage.tsx — T095
// Page 404 — ressource introuvable.

import { Link } from "@tanstack/react-router";
import { Search } from "lucide-react";

import { Button } from "@/presentation/components/shared/ui/button";

export function NotFoundPage() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 p-8 text-center"
      role="main"
      aria-labelledby="not-found-title"
    >
      <Search className="h-16 w-16 text-muted-foreground" aria-hidden="true" />
      <div className="space-y-2">
        <h1 id="not-found-title" className="text-3xl font-semibold">
          Page introuvable
        </h1>
        <p className="text-muted-foreground">
          La page que vous cherchez n&apos;existe pas ou a été déplacée.
        </p>
      </div>
      <Button asChild>
        <Link to="/dashboard">Retour au tableau de bord</Link>
      </Button>
    </div>
  );
}
